import ServicesScreen from './components/ServicesScreen'

export default {
  path: '/servicios',
  component: ServicesScreen,
  name: 'Services'
}



// WEBPACK FOOTER //
// ./src/app/screens/Services/index.js